import { useQuery } from '@tanstack/react-query';
import constate from 'constate';
import type React from 'react';

import { QueryLoader } from '@/core/providers/QueryLoader';

type Config = {
	// TODO: remove instance_id after migration to SaaS
	// @deprecated
	instance_id: string;
	cluster_id: string;
	env_id: string;
	urls: {
		backend: string;
		api: string;
		tdm: string;
		cs: string;
	};
	auth: {
		clerk_publishable_key: string;
	};
	amplitude?: {
		api_key: string;
	};
	sentry?: {
		dsn?: string;
	};
};

const [ConfigStateProvider, useConfigState] = constate((props: { value: Config }) => {
	return props.value;
});

export const useConfig = useConfigState;

export const ConfigProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const configQuery = useQuery<Config>({
		queryKey: ['config'],
		queryFn: async () => {
			const res = await fetch(`/env.json?ts=${Date.now()}`);
			if (!res.ok) {
				throw new Error('Invalid response');
			}

			return res.json();
		},
	});

	return (
		<QueryLoader
			query={configQuery}
			errorMessage="Failed to load config"
			renderData={(data) => {
				return <ConfigStateProvider value={data}>{children}</ConfigStateProvider>;
			}}
		/>
	);
};
